import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className="py-3 sm:py-4 px-4 sm:px-8 bg-white/95 border-b border-gray-300 text-black rounded-none z-[5] sticky top-0 backdrop-blur-md">
      <div className="flex items-center max-w-7xl mx-auto gap-3 sm:gap-4 relative w-full">
        <div className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('/')}>
          <img 
            src="/deped-logo.png" 
            alt="DepEd Logo" 
            className="h-10 sm:h-12"
          />
          <h1 className="font-extrabold text-slate-800 text-lg sm:text-xl font-poppins tracking-tight">
            Ticketing System
          </h1>
        </div>
        <button 
          aria-label="Admin Login"
          className="ml-auto text-slate-900 bg-slate-100/80 hover:bg-slate-200 p-2 rounded-lg transition-colors"
          onClick={() => navigate('/login')}
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Header;